import React from 'react';

export const NotFound = () => {
  return <h1>404 Not Found</h1>;
};
